import { useState, ChangeEvent, FormEvent, useEffect } from 'react';
import Spinner from 'components/Spinner/Spinner';

import { Div } from 'styles/Styles';
import { FormTitle } from '../Auth.styled';
import { colors } from 'styles/GlobalStyles';
import { H2, P2 } from 'styles/FontStyles';
import { InputComponent } from 'components/Input/Input';

import { Button } from 'components/Button/Button';
import { sendResetPasswordEmail } from 'services/auth/auth.service';
import { useAppDispatch } from 'app/hooks';

import { validateEmail } from 'helpers/helpers';
import { ResetPasswordTypes } from '../auth.types';

export const ResetPassword = () => {
  const [userId, setUserId] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const digit = /^\d+$/;

  const dispatch = useAppDispatch();

  const onFormSubmit = (e: FormEvent) => {
    e.preventDefault();

    if (validateEmail(userId)) {
      dispatch(
        sendResetPasswordEmail({
          userId,
          type: ResetPasswordTypes.EMAIL,
          setLoading,
        })
      );
    } else if (userId.match(digit)) {
      dispatch(
        sendResetPasswordEmail({
          userId,
          type: ResetPasswordTypes.ID,
          setLoading,
        })
      );
    } else {
      dispatch(
        sendResetPasswordEmail({
          userId,
          type: ResetPasswordTypes.USERNAME,
          setLoading,
        })
      );
    }

    // setCaptchaLoading(true);

    // window.initGeetest4(
    //   {
    //     captchaId,
    //     language: 'eng',
    //     product: 'bind',
    //     riskType: 'slide',
    //     nativeButton: {
    //       width: '100%',
    //       marginBottom: '20px'
    //     }
    //   },
    //   function (captcha: any) {
    //     captcha.showBox();
    //     captcha
    //       .onReady(function () {
    //         setCaptchaLoading(false);
    //       })
    //       .onSuccess(function () {
    //         const result = captcha.getValidate();
    //         if (validateEmail(id)) {
    //           dispatch(sendResetPasswordEmail({ id, type: 1, result }));
    //         } else if (id.match(digit)) {
    //           dispatch(sendResetPasswordEmail({ id, type: 2, result }));
    //         } else {
    //           dispatch(sendResetPasswordEmail({ id, type: 3, result }));
    //         }
    //       })
    //       .onError(function () {
    //         setCaptchaLoading(false);
    //       });
    //   }
    // );
  };

  return (
    <>
      {loading && <Spinner fullscreen={true} transparent />}
      <Div $box $width='50%' $widthSM='100%'>
        <H2 center m='50px 0' color={colors.primary}>
          Reset Your Password
        </H2>

        <form onSubmit={onFormSubmit}>
          <InputComponent
            placeholder='Enter email, ID or username'
            label='Email'
            value={userId}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setUserId(e.target.value)
            }
          />

          <Button
            style={{ marginTop: 20 }}
            type='submit'
            disabled={userId === ''}
          >
            Send link to email
          </Button>
          <P2 color={colors.white} mt='20' center>
            Please check all your email folders, including Spam and Junk.
          </P2>
        </form>
      </Div>
    </>
  );
};
